import { render } from "./Eurorescue.vue?vue&type=template&id=c0a143b4&scoped=true"
import script from "./Eurorescue.vue?vue&type=script&lang=js"
export * from "./Eurorescue.vue?vue&type=script&lang=js"

import "./Eurorescue.vue?vue&type=style&index=0&id=c0a143b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a143b4"]])

export default __exports__